'use client';

import * as React from 'react';
import Image from 'next/image';
import { KycDataMap, KycOption, PlayerKycV2 } from '@alien-platform/bo-core';
import { Card, CardContent, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import { Row } from '@/types/general';
import { camelCaseToWords } from '@/lib/helpers';
import { HorizontalTable } from '@/components/core/horizontal-table';
import { SettingsSection } from '@/components/core/settings-section';

export function KycItemDetails({ kycItem }: { kycItem: PlayerKycV2 }): React.JSX.Element | null {
  // const hasEditPermissions = checkPermissionsClient({
  //   componentId: 'edit_kyc_data',
  // });
  switch (kycItem.optionType) {
    case KycOption.PASSPORT_COPY:
      return (
        <Card sx={{ width: 1 }}>
          <CardContent>
            <Typography variant="subtitle1">Passport Image</Typography>
            {(kycItem.data as KycDataMap['PASSPORT_COPY']).imageUrl ? (
              <Stack gap={1} sx={{ width: 1 }}>
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    maxHeight: '200px',
                    aspectRatio: '16 / 9',
                  }}
                >
                  <Image
                    src={(kycItem.data as KycDataMap['PASSPORT_COPY']).imageUrl}
                    alt="Responsive"
                    fill
                    style={{ objectFit: 'contain' }}
                  />
                </div>

                {/* <ImageButtons imageUrl={(kycItem.data as KycDataMap['PASSPORT_COPY']).imageUrl} /> */}
              </Stack>
            ) : null}
          </CardContent>
        </Card>
      );
    case KycOption.CARD_COPY:
      return (
        <Stack direction="row" gap={2} sx={{ width: 1 }}>
          <Card sx={{ width: 1 }}>
            <CardContent>
              <Typography variant="subtitle1">Front Image</Typography>
              {(kycItem.data as KycDataMap['CARD_COPY']).frontImageUrl ? (
                <Stack gap={1} sx={{ width: 1 }}>
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxHeight: '200px',
                      aspectRatio: '16 / 9',
                    }}
                  >
                    <Image
                      src={(kycItem.data as KycDataMap['CARD_COPY']).frontImageUrl}
                      alt="Responsive"
                      fill
                      style={{ objectFit: 'contain' }}
                    />
                  </div>

                  {/* <ImageButtons imageUrl={(kycItem.data as KycDataMap['CARD_COPY']).frontImageUrl} /> */}
                </Stack>
              ) : null}
            </CardContent>
          </Card>
          <Card sx={{ width: 1 }}>
            <CardContent>
              <Typography variant="subtitle1">Front Image</Typography>

              {(kycItem.data as KycDataMap['CARD_COPY']).backImageUrl ? (
                <SettingsSection
                  title="Back Image"
                  sx={{ width: 1 }}
                  content={
                    (kycItem.data as KycDataMap['CARD_COPY']).backImageUrl ? (
                      <Stack gap={1} sx={{ width: 1 }}>
                        <div
                          style={{
                            position: 'relative',
                            width: '100%',
                            maxHeight: '200px',
                            aspectRatio: '16 / 9',
                          }}
                        >
                          <Image
                            src={(kycItem.data as KycDataMap['CARD_COPY']).backImageUrl || ''}
                            alt="Responsive"
                            fill
                            style={{ objectFit: 'contain' }}
                          />
                        </div>

                        {/* <ImageButtons imageUrl={(kycItem.data as KycDataMap['CARD_COPY']).backImageUrl || ''} /> */}
                      </Stack>
                    ) : null
                  }
                />
              ) : null}
            </CardContent>
          </Card>
        </Stack>
      );

    case KycOption.EMAIL:
    case KycOption.MOBILE_NUMBER:
    case KycOption.ADDRESS:
    case KycOption.PERSONAL_DETAILS:
    case KycOption.PASSPORT_ID:
    case KycOption.CARD_ID: {
      const data = kycItem.data as Record<string, string>;
      const tableData: Row[] = Object.entries(data).map(([key, value]) => ({
        label: { text: camelCaseToWords(key) },
        value: { text: value },
      }));
      return (
        <HorizontalTable tableData={tableData} />
        // <SettingsSection
        //   title="KYC Details"
        //   content={
        //     <Stack>
        //       {Object.entries(data).map(([key, value]) => (
        //         <CustomConfigInputV2
        //           key={key}
        //           readOnly
        //           label={camelCaseToWords(key).toUpperCase()}
        //           value={value}
        //           name={key}
        //           type={key === 'address' ? InputType.MULTILINE_INPUT : InputType.INPUT}
        //         />
        //       ))}
        //     </Stack>
        //   }
        // />
      );
    }

    default:
      return <div>Unsupported KYC type: {kycItem.optionType}</div>;
  }
}
